<template>
    <!-- Emergency center -->
    <v-select 
        :items="emergencyCenters"
        item-text="name"
        item-value="id"
        :menu-props="{bottom: true, offsetY: true}"
        v-model="$store.state.display.elevatorForm.elevator.emergencyCenter"
        outlined
        clearable
        :label="$t('display/elevator:edit.labels.data-tab.emergency-center')"
    />

</template>

<script>
import EmergencyCenterService from '@/modules/display/services/emergency-center-service';

export default {
    name: "EmergencyCenter",
    data() {
        return {
            emergencyCenters: []
        }
    },
    methods: {
        loadCenters() {
           EmergencyCenterService.readAllFromAPI(
               (response) => {
                   this.emergencyCenters = response.data;
               }
           )
        }
    },
    created() {
        this.loadCenters();
    }
}
</script>